export default class ImpfSetting {
    public setting_code: string | null = null;
    public displayname: string | null = null;
    public ordernumber: number | null = null;

    constructor(data?: Partial<ImpfSetting>) {
        Object.assign(this, data);
    }
}
